﻿import { isLoggedIn } from "./utilities";
import {getSearchParam, valueFilters} from "./overview-filter-state";

const track = (items) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(items);
	console.log(`${new Date()}: ${JSON.stringify(items)}`);
}

export const trackContactSuccess = () => {
	track({
		"event": "event-track",
		"category": "website action",
		"action": "webform submission",
		"label": "vacature_email",
	});
}

export const trackVacancySearchAlertSuccess = (formData) => {
	trackVacancyAlertSuccess();

	// Happy Horizon Event
	track({
		"event": "event-track",
		"custom_event_name": "vacancy_alert",
		"logged_in": isLoggedIn(),
		"vacancy_alert_search_term": formData.get('Term') ?? '',
		"vacancy_alert_area": `${formData.get('Location')} + ${formData.get('Radius')}km`,
		"enhanced_conversion_data": {
			"email": formData.get('Email'),
		}
	});
}

export const trackVacancyDetailAlertSuccess = (vacancyId, vacancyTitle, term, email, location, radius) => {
	trackVacancyAlertSuccess();

	// Happy Horizon Event
	track({
		"event": "event-track",
		"custom_event_name": "vacancy_alert",
		"logged_in": isLoggedIn(),
		"vacancy_alert_search_term": term,
		"vacancy_alert_area": `${location} + ${radius}km`,
		"vacancy_alert_id": vacancyId,
		"vacancy_alert_title": vacancyTitle,
		"enhanced_conversion_data": {
			"email": email,
		}
	});
}

export const trackVacancyAlertSuccess = () => {
	const page = window.location.pathname.indexOf("/vacature/") === 0 ? "vdp" : "vop";
	const userState = isLoggedIn() ? "ingelogd" : "uitgelogd";

	track({
		"event": "event-track",
		"category": "website action",
		"action": "send vacancy alert",
		"label": `${page} - ${userState}`
	});
}

export const trackVacancySearch = () => {
	const term = getSearchParam(valueFilters.searchTerm);
	const location = getSearchParam(valueFilters.location);
	const radius = getSearchParam(valueFilters.radius);

	const searchArea = location && radius ? `${location} + ${radius}km` : "-";
	const searchTerm = term ? term : "-";
	const currentSearchTrackingObject =
		{
			"event": "event-track",
			custom_event_name: 'vacancy_search',
			vacancy_search_term: searchTerm,
			vacancy_search_area: searchArea,
			"category": "vacature zoekactie", // Old tracking (until August 2025)
			"action": searchTerm, // Old tracking (until August 2025)
			"label": searchArea, // Old tracking (until August 2025)
		};

	const existingSearchTracking = localStorage.getItem("vacancySearchTracking");
	const currentSearchTracking = JSON.stringify(currentSearchTrackingObject);

	if (existingSearchTracking !== currentSearchTracking && (searchTerm !== "-" || searchArea !== "-")) {
		track(currentSearchTrackingObject);
		localStorage.setItem("vacancySearchTracking", currentSearchTracking);
	}
}


